import { isTeamCercle } from 'utils'

import { ButtonLink } from '../../../shared/components/button'
import { useStoryblokTranslationsContext } from '../../../storyblok/context/translations-provider'
import { useTranslations } from '../../../storyblok/hooks/useTranslations'
import { timestampToLocaleDatestring } from '../../utils/timestampToLocaleDate'
import { MatchClub } from '../match-club'
import { MatchLeague } from '../match-league'
import { isValidLink } from '../match-live-card'

import {
  StContainer,
  StDate,
  StMatchday,
  StTime,
  StTimeContainer,
  StLeftContainer,
  StCenterContainer,
  StRightContainer,
  StScore,
} from './MatchResultCard.styled'

import type { StoryblokImage } from 'types'

type MatchResultCardProps = {
  className?: string
  date: string
  home_team: string
  home_team_logo?: StoryblokImage
  home_team_goals?: string
  away_team: string
  away_team_logo?: StoryblokImage
  away_team_goals?: string
  league_name?: string
  league_logo?: StoryblokImage
  league_match_info?: string
  locale: string
  no_score: string
  report_title?: string
  report_link?: string
  live_updates?: string
}

export const MatchResultCard = ({
  className,
  date,
  home_team,
  home_team_logo,
  home_team_goals,
  away_team,
  away_team_logo,
  away_team_goals,
  league_name,
  league_logo,
  league_match_info,
  locale,
  no_score,
  report_title,
  report_link,
  live_updates,
}: MatchResultCardProps) => {
  const { translations } = useStoryblokTranslationsContext()
  const { t } = useTranslations(translations)

  return (
    <StContainer className={className}>
      <StLeftContainer>
        <MatchLeague
          name={league_name ?? ''}
          logo={league_logo}
          info={league_match_info}
        ></MatchLeague>
      </StLeftContainer>
      <StCenterContainer>
        <MatchClub name={home_team} logo={home_team_logo} />
        <StMatchday>
          <StDate>{timestampToLocaleDatestring(date, locale)}</StDate>
          {home_team_goals && away_team_goals ? (
            <StTimeContainer>
              <StTime>
                <StScore isCercle={isTeamCercle(home_team)}>
                  {home_team_goals}
                </StScore>{' '}
                -{' '}
                <StScore isCercle={isTeamCercle(away_team)}>
                  {away_team_goals}
                </StScore>
              </StTime>
            </StTimeContainer>
          ) : (
            <StTimeContainer>
              <StTime>{no_score}</StTime>
            </StTimeContainer>
          )}
        </StMatchday>
        <MatchClub name={away_team} logo={away_team_logo} />
      </StCenterContainer>
      <StRightContainer>
        {live_updates && live_updates !== '' && (
          <ButtonLink variant="secondary" size="small" href={live_updates}>
            {t('match_card_live')}
          </ButtonLink>
        )}
        {report_link && isValidLink(report_link) && (
          <ButtonLink variant="secondary" size="small" href={report_link}>
            {report_title ?? t('match_card_report')}
          </ButtonLink>
        )}
      </StRightContainer>
    </StContainer>
  )
}
